import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { january2026Data } from './january2026Data';
import { february2026Data } from './february2026Data';
import { march2026Data } from './march2026Data';
import { april2026Data } from './april2026Data';
import { may2026Data } from './may2026Data';
import { june2026Data } from './june2026Data';
import { july2026Data } from './july2026Data';

// REMINDER: When adding a new 2026 month:
// 1. Import the new month's data above
// 2. Add it to the allMonthlyReports array below
// 3. Update the endMonth in the period object
// 4. Update the title in StandaloneYTD2026Report.tsx

const allMonthlyReports = [
  january2026Data,
  february2026Data,
  march2026Data,
  april2026Data,
  may2026Data,
  june2026Data,
  july2026Data
];

const combinedData = combineReports(allMonthlyReports, 'YTD Report 2026');

export const ytd2026Data: ReportData = {
  ...combinedData,
  period: {
    month: 7,
    startMonth: 1,
    endMonth: 7,
    year: 2026,
    ytd: true
  }
};
